import { Injectable } from '@angular/core';


interface PositionTrad {
	cod_es: string;
	cod_en: string;
	name_en: string;
}
@Injectable({
  providedIn: 'root',
})
export class PositionsService {
	public STATIC_POSITIONS:Record<string, PositionTrad> = {
		"POR": {
			"cod_es": "POR",
			"cod_en": "GK",
			"name_en": "Goalkeeper"
		},
		"DFCD": {
			"cod_es": "DFCD",
			"cod_en": "RCB",
			"name_en": "Rightcenter back"
		},
		"DFCI": {
			"cod_es": "DFCI",
			"cod_en": "LCB",
			"name_en": "Left center back"
		},
		"LD": {
			"cod_es": "LD",
			"cod_en": "RB",
			"name_en": "Right back"
		},
		"LI": {
			"cod_es": "LI",
			"cod_en": "LB",
			"name_en": "Left back"
		},
		"MCD": {
			"cod_es": "MCD",
			"cod_en": "DMF",
			"name_en": "Defensive midfielder"
		},
		"MI": {
			"cod_es": "MI",
			"cod_en": "LMF",
			"name_en": "Left midfielder"
		},
		"MD": {
			"cod_es": "MD",
			"cod_en": "RMF",
			"name_en": "Right midfielder"
		},
		"MC": {
			"cod_es": "MC",
			"cod_en": "CMF",
			"name_en": "Center midfielder"
		},
		"ED": {
			"cod_es": "ED",
			"cod_en": "RW",
			"name_en": "Right winger"
		},
		"EI": {
			"cod_es": "EI",
			"cod_en": "LW",
			"name_en": "Left winger"
		},
		"MCO": {
			"cod_es": "MCO",
			"cod_en": "AMF",
			"name_en": "Attacking midfielder"
		},
		"SD": {
			"cod_es": "SD",
			"cod_en": "SST",
			"name_en": "Second striker"
		},
		"DC": {
			"cod_es": "DC",
			"cod_en": "ST",
			"name_en": "Striker"
		}
	};
}
